import { routeName } from '@/pages/profile/router/types';

interface IProfileRouter {
  path: string;
  name: string;
  redirectTo404: Redirect;
}

export type Redirect = (module: string) => void;
export type RedirectOrNull = Redirect | null;
export const rootRouteName = routeName.ROOT;

export default IProfileRouter;



// WEBPACK FOOTER //
// ./src/pages/profile/modules/mentoring/router/types.ts